import React from "react"
import Icon from "src/shared/icons"
import { RoomCardHeaderProps } from "../../../../interfaces/RoomCardHeaderProps"
import { useModulos } from "src/shared/hooks/useModulos"
import { formatTime } from "src/shared/utils/formatTime"

import "./RoomCardHeader.css"

const RoomCardHeader = ({
    iconName,
    roomNumber,
    iconBgColor = "var(--white)",
    hasIncidences,
    roomTypeAbbreviation,
    iconBgSecondaryColor,
    easyrewards,
    orderTimer,
    paymentPendingTimer,
    timeout,
}: Omit<RoomCardHeaderProps, "roomTypeName">) => {
    const { easyRewards: withEasyrewards } = useModulos()
    return (
        <div className="room-card-header--sm">
            <div className="room-card--sm-header__left__wrapper">
                <div
                    className="room-card--sm-header__icon-wrapper"
                    style={{
                        backgroundColor: iconBgColor,
                    }}
                >
                    <Icon
                        name={iconName}
                        width={20}
                        height={20}
                        color="var(--white)"
                        secondarycolor={iconBgSecondaryColor}
                    />
                </div>
                {!!orderTimer && (
                    <span
                        className={
                            timeout
                                ? "room-card--sm-header__payment-timer--timeout"
                                : "room-card--sm-header__payment-timer"
                        }
                    >
                        {formatTime({ time: orderTimer, withHours: true })}
                    </span>
                )}
                {!!paymentPendingTimer && (
                    <span
                        className={
                            timeout
                                ? "room-card--sm-header__payment-timer--timeout"
                                : "room-card--sm-header__payment-timer"
                        }
                    >
                        {paymentPendingTimer}
                    </span>
                )}
            </div>
            <span style={{ display: "flex", alignItems: "center", height: "fit-content", columnGap: "3px" }}>
                {!!hasIncidences && <Icon name="alertFill" color="var(--orange-warning)" width={14} height={14} />}
                <span>
                    {!!roomTypeAbbreviation && (
                        <span className="room-card-header--sm__room-type-abbreviation">{roomTypeAbbreviation}-</span>
                    )}
                    <span className="room-card-header--sm__number">{roomNumber}</span>
                    {easyrewards && withEasyrewards && (
                        <div className="gift-icon-wrapper">
                            <Icon name="giftFill" width={14} height={14} color="var(--purple-drawer-primario)" />
                        </div>
                    )}
                </span>
            </span>
        </div>
    )
}

export default RoomCardHeader
